import {NgModule} from '@angular/core';
import {ConsultationCategoryModule} from './category/consultationCategory.module';
import {ConsultationConsultationModule} from './consultation/consultationConsultation.module';
import {errorMessages} from "../../core/error/errorMessages";

@NgModule({
    imports: [
        ConsultationConsultationModule,
        ConsultationCategoryModule,
    ]
})
export class ConsultationModule {

    constructor() {
        errorMessages.set('MEDICAL_CONSULTATION_AUDIO_HISTORY_NO_PREVIOUS_DATA',
            'Le patient n\'a pas d\'historique.');
    }
}
